import React from 'react';

const Card = ({ children, title, border, green }) => {
  return (
    <div className="border border-cf-300 rounded bg-white shadow-cfw p-5">
      <p className={green ? 'text-base font-header text-cf-300' : 'text-base font-header mb-4'}>
        {title}
      </p>

      {children}

      {border && <div className="border-b border-cf-300 w-40 mx-auto py-2"></div>}
    </div>
  );
};

export default Card;
